exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-member[data-v-30b92877] {\n  width: 200px;\n  height: 200px;\n}\n.img-radius[data-v-30b92877] {\n  border-radius: 50%;\n}", ""]);

// exports
